import React from 'react';
import { useStyletron } from 'baseui';
const AskingCarlosSpinner = ({
  size = 50
}) => {
  const [css] = useStyletron();
  return <div className={css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    width: '100%'
  })}>
      <svg width={size} height={size} viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <filter id="glow">
            <feGaussianBlur stdDeviation="0.5" result="coloredBlur" />
            <feMerge>
              <feMergeNode in="coloredBlur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>
        <style>
          {`
          @keyframes pulse {
            0%, 100% { r: 1; fill-opacity: 1; }
            50% { r: 1.5; fill-opacity: 0.8; }
          }
          @keyframes dash {
            to { stroke-dashoffset: 0; }
          }
          .node {
            fill: #FCB913;
            filter: url(#glow);
          }
          .link {
            stroke: #FCB913;
            stroke-width: 0.5;
            stroke-linecap: round;
            fill: none;
            filter: url(#glow);
          }
          .pulse-1 { animation: pulse 2s ease-in-out infinite; }
          .pulse-2 { animation: pulse 2s ease-in-out infinite 0.5s; }
          .pulse-3 { animation: pulse 2s ease-in-out infinite 1s; }
          .dash-1 { stroke-dasharray: 22.5; stroke-dashoffset: 22.5; animation: dash 3s linear infinite; }
          .dash-2 { stroke-dasharray: 35; stroke-dashoffset: 35; animation: dash 3s linear infinite 0.5s; }
          .dash-3 { stroke-dasharray: 27.5; stroke-dashoffset: 27.5; animation: dash 3s linear infinite 1s; }
        `}
        </style>
        <g transform="translate(25 25)">
          {/* Central node */}
          <circle className="node pulse-1" cx="0" cy="0" r="2.5" />

          {/* Outer nodes */}
          <circle className="node pulse-2" cx="-15" cy="-15" r="1.5" />
          <circle className="node pulse-3" cx="15" cy="-15" r="1.5" />
          <circle className="node pulse-2" cx="15" cy="15" r="1.5" />
          <circle className="node pulse-3" cx="-15" cy="15" r="1.5" />

          {/* Connections */}
          <path className="link dash-1" d="M0,0 Q-7.5,-7.5 -15,-15" />
          <path className="link dash-2" d="M0,0 Q7.5,-7.5 15,-15" />
          <path className="link dash-3" d="M0,0 Q7.5,7.5 15,15" />
          <path className="link dash-1" d="M0,0 Q-7.5,7.5 -15,15" />

          {/* Additional connections */}
          <path className="link dash-2" d="M-15,-15 Q0,-20 15,-15" />
          <path className="link dash-3" d="M-15,15 Q0,20 15,15" />
        </g>
      </svg>
      <span className={css({
      display: 'inline-block',
      marginLeft: '8px',
      animation: 'pulse 1.5s ease-in-out infinite',
      '@keyframes pulse': {
        '0%, 100%': {
          opacity: 1
        },
        '50%': {
          opacity: 0.5
        }
      }
    })}>
        Asking Carlos...
      </span>
    </div>;
};
export default AskingCarlosSpinner;